/* ==========================================================================
   SealVault — theme behavior
   ========================================================================== */
(function () {
  'use strict';

  const routes = (window.theme && window.theme.routes) || {};
  const leadCfg = (window.theme && window.theme.leadCapture) || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Toast ---------- */
  function toast(message) {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2200);
  }

  /* ---------- Cart drawer ---------- */
  const drawer = $('#CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    closeLeadModal();
    closePremiumFlyer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!isModalOpen()) document.body.style.overflow = '';
  }

  function isModalOpen() {
    return $('.lead-modal.is-open') || $('.premium-flyer.is-open');
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function cartAdd(formData, button) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) {
        toast(data.description || data.message || 'Could not add to cart');
        return;
      }
      updateCartCount(data.item_count);
      await reloadDrawerContents();
      openDrawer();
      toast('Added to cart');
    } catch (e) {
      console.error(e);
      toast('Something went wrong');
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(key, quantity) {
    try {
      const res = await fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      await reloadDrawerContents();
      if ($('[data-cart-page]')) window.location.reload();
    } catch (e) {
      console.error(e);
      toast('Could not update cart');
    }
  }

  async function reloadDrawerContents() {
    const body = $('#CartDrawerBody');
    if (!body) return;
    try {
      const res = await fetch(window.location.href, { headers: { 'X-Requested-With': 'fetch' } });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('#CartDrawerBody');
      if (fresh) body.innerHTML = fresh.innerHTML;
    } catch (e) {
      console.error('Drawer reload failed', e);
    }
  }

  /* ---------- Lead capture modal ---------- */
  const leadModal = $('#LeadModal');
  const LEAD_KEY = 'sealvault_lead_captured';

  function openLeadModal() {
    if (!leadModal) return;
    closeDrawer();
    closePremiumFlyer();
    leadModal.classList.add('is-open');
    leadModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLeadModal() {
    if (!leadModal) return;
    leadModal.classList.remove('is-open');
    leadModal.setAttribute('aria-hidden', 'true');
    if (!drawer?.classList.contains('is-open') && !$('#PremiumFlyer')?.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function showLeadSuccess() {
    const wrap = $('[data-lead-form-wrap]', leadModal);
    const success = $('[data-lead-success]', leadModal);
    if (wrap) wrap.hidden = true;
    if (success) success.hidden = false;
    localStorage.setItem(LEAD_KEY, '1');
  }

  /* ---------- Premium products flyer ---------- */
  const premiumFlyer = $('#PremiumFlyer');
  const PREMIUM_FLYER_KEY = 'sealvault_premium_flyer_dismissed';
  let premiumFlyerOpen = false;

  function premiumFlyerStorage() {
    const mode = premiumFlyer?.getAttribute('data-storage') || 'local';
    return mode === 'session' ? sessionStorage : localStorage;
  }

  function isPremiumFlyerDismissed() {
    return !!premiumFlyerStorage().getItem(PREMIUM_FLYER_KEY);
  }

  function dismissPremiumFlyer() {
    premiumFlyerStorage().setItem(PREMIUM_FLYER_KEY, '1');
  }

  function shouldShowPremiumFlyer() {
    if (!premiumFlyer) return false;
    if (isPremiumFlyerDismissed()) return false;
    if (premiumFlyer.getAttribute('data-ad-only') === 'true' && !document.body.classList.contains('landing-from-ads')) {
      return false;
    }
    return true;
  }

  function trapFocus(panel, e) {
    const focusable = $$(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
      panel
    ).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openPremiumFlyer() {
    if (!premiumFlyer || premiumFlyerOpen) return;
    closeDrawer();
    closeLeadModal();
    const panel = $('[data-premium-flyer-panel]', premiumFlyer);
    premiumFlyer.classList.add('is-open');
    premiumFlyer.setAttribute('aria-hidden', 'false');
    premiumFlyerOpen = true;
    document.body.style.overflow = 'hidden';
    panel?.focus();
  }

  function closePremiumFlyer(persistDismiss) {
    if (!premiumFlyer) return;
    premiumFlyer.classList.remove('is-open');
    premiumFlyer.setAttribute('aria-hidden', 'true');
    premiumFlyerOpen = false;
    if (persistDismiss) dismissPremiumFlyer();
    if (!drawer?.classList.contains('is-open') && !leadModal?.classList.contains('is-open')) {
      document.body.style.overflow = '';
    }
  }

  function initPremiumFlyer() {
    if (!premiumFlyer || !shouldShowPremiumFlyer()) return;

    const delaySec = parseInt(premiumFlyer.getAttribute('data-delay') || '15', 10);
    setTimeout(() => {
      if (shouldShowPremiumFlyer() && !premiumFlyerOpen && !isModalOpen()) openPremiumFlyer();
    }, delaySec * 1000);

    const panel = $('[data-premium-flyer-panel]', premiumFlyer);
    panel?.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && premiumFlyerOpen) trapFocus(panel, e);
    });
  }

  function getLeadCaptureDelaySec() {
    const isLanding = document.body.classList.contains('landing-from-ads');
    let delaySec = isLanding ? 45 : (leadCfg.delay || 8);
    if (premiumFlyer && shouldShowPremiumFlyer()) {
      const premiumDelay = parseInt(premiumFlyer.getAttribute('data-delay') || '15', 10);
      delaySec = Math.max(delaySec, premiumDelay + 18);
    }
    return delaySec;
  }

  function initLeadCapture() {
    if (!leadModal || !leadCfg.enabled) return;
    if (localStorage.getItem(LEAD_KEY)) return;

    const delaySec = getLeadCaptureDelaySec();
    const delay = delaySec * 1000;

    setTimeout(() => {
      if (localStorage.getItem(LEAD_KEY) || premiumFlyerOpen) return;
      openLeadModal();
    }, delay);

    const form = $('#LeadCaptureForm', leadModal);
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
        try {
          await fetch('/contact', {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
          });
          showLeadSuccess();
          toast('Welcome code unlocked!');
        } catch (err) {
          console.error(err);
          toast('Could not subscribe — try again');
        } finally {
          if (btn) btn.classList.remove('is-loading');
        }
      });
    }
  }

  /* ---------- Countdown timer ---------- */
  function initCountdown() {
    const el = $('[data-flash-deal]');
    if (!el) return;
    const endStr = el.getAttribute('data-end');
    if (!endStr) return;
    const end = new Date(endStr).getTime();
    const hoursEl = $('[data-countdown-hours]', el);
    const minsEl = $('[data-countdown-mins]', el);
    const secsEl = $('[data-countdown-secs]', el);
    if (!hoursEl || !minsEl || !secsEl) return;

    function tick() {
      const diff = Math.max(0, end - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      hoursEl.textContent = String(h).padStart(2, '0');
      minsEl.textContent = String(m).padStart(2, '0');
      secsEl.textContent = String(s).padStart(2, '0');
      if (diff <= 0) el.hidden = true;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Mobile buy bar ---------- */
  function initMobileBuyBar() {
    const bar = $('[data-mobile-buy-bar]');
    const form = $('#ProductForm');
    const addBtn = $('[data-mobile-add]');
    if (!bar || !form) return;

    bar.hidden = false;

  if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (addBtn.disabled) return;
        cartAdd(new FormData(form), addBtn);
      });
    }

    const mainAdd = $('[data-add-button]', form);
    if (mainAdd) {
      const observer = new IntersectionObserver((entries) => {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      observer.observe(mainAdd);
    }
  }

  /* ---------- Variant selection ---------- */
  function initProductForm(root) {
    const form = $('#ProductForm', root) || $('form.product-form', root);
    if (!form) return;
    const dataEl = $('[data-variant-json]', root);

    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const mobileAdd = $('[data-mobile-add]');
    const addText = $('[data-add-text]', root);

    if (dataEl) {
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const selected = {};

      function syncSelectionFromUI() {
        $$('[data-option-index]', root).forEach((group) => {
          const idx = parseInt(group.getAttribute('data-option-index'), 10);
          const active = $('.is-selected', group);
          if (active) selected[idx] = active.getAttribute('data-value');
        });
      }

      function findVariant() {
        return variants.find((v) =>
          Object.keys(selected).every((idx) => v.options[idx] === selected[idx])
        );
      }

      function update() {
        const variant = findVariant();
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          if (mobileAdd) mobileAdd.disabled = true;
          if (addText) addText.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = variant.id;
        const available = variant.available;
        if (addBtn) addBtn.disabled = !available;
        if (mobileAdd) mobileAdd.disabled = !available;
        const label = available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
        if (addText) addText.textContent = label;
        if (mobileAdd) mobileAdd.textContent = label;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      $$('[data-option-value]', root).forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.closest('[data-option-index]');
          $$('[data-option-value]', group).forEach((b) => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
          syncSelectionFromUI();
          update();
        });
      });

      syncSelectionFromUI();
      update();
    }

    $$('[data-thumb]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const full = thumb.getAttribute('data-full');
        const main = $('.product-page__image', root);
        if (full && main) main.src = full;
        $$('[data-thumb]', root).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initQuantity(root) {
    $$('[data-qty]', root).forEach((wrap) => {
      const input = $('[data-qty-input]', wrap);
      $('[data-qty-minus]', wrap)?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      $('[data-qty-plus]', wrap)?.addEventListener('click', () => {
        input.value = parseInt(input.value || '1', 10) + 1;
      });
    });
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      reloadDrawerContents();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    if (e.target.closest('[data-lead-open]')) {
      e.preventDefault();
      openLeadModal();
      return;
    }
    if (e.target.closest('[data-lead-close]')) {
      closeLeadModal();
      return;
    }
    if (e.target.closest('[data-premium-flyer-close]')) {
      closePremiumFlyer(true);
      return;
    }

    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const menu = $('[data-menu]');
      const open = menu?.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    const minus = e.target.closest('[data-line-minus]');
    const plus = e.target.closest('[data-line-plus]');
    const remove = e.target.closest('[data-line-remove]');
    if (minus || plus || remove) {
      const trigger = minus || plus || remove;
      const key = trigger.getAttribute('data-key');
      const input = $(`[data-line-input][data-key="${key}"]`);
      let qty = input ? parseInt(input.value, 10) : 1;
      if (minus) qty = Math.max(0, qty - 1);
      else if (plus) qty = qty + 1;
      else if (remove) qty = 0;
      changeLine(key, qty);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
      if (premiumFlyerOpen) closePremiumFlyer(true);
      else closeLeadModal();
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) {
      const key = input.getAttribute('data-key');
      changeLine(key, Math.max(0, parseInt(input.value || '0', 10)));
    }
  });

  document.addEventListener('submit', (e) => {
    const quickAdd = e.target.closest('[data-quick-add]');
    const productForm = e.target.closest('form.product-form');
    if (quickAdd) {
      e.preventDefault();
      cartAdd(new FormData(quickAdd), $('[data-quick-add-btn]', quickAdd));
      return;
    }
    if (productForm) {
      e.preventDefault();
      cartAdd(new FormData(productForm), $('[data-add-button]', productForm));
    }
  });

  function initLandingPage() {
    document.addEventListener('click', (e) => {
      const scrollBtn = e.target.closest('[data-scroll-shop]');
      if (scrollBtn) {
        const shop = document.getElementById('shop');
        if (shop) {
          e.preventDefault();
          shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      const copyBtn = e.target.closest('[data-copy-trigger]');
      if (copyBtn) {
        const code = copyBtn.getAttribute('data-copy');
        if (code && navigator.clipboard) {
          navigator.clipboard.writeText(code).then(() => toast('Code copied!')).catch(() => toast(code));
        } else if (code) toast(code);
      }
    });

    const sticky = $('[data-landing-sticky]');
    if (sticky && document.body.classList.contains('landing-from-ads')) {
      sticky.hidden = false;
    }
  }

  function init() {
    initLandingPage();
    initPremiumFlyer();
    initLeadCapture();
    initCountdown();
    initMobileBuyBar();

    const productRoot = $('.product-page');
    if (productRoot) {
      initProductForm(productRoot);
      initQuantity(productRoot);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
